// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  max-width: 600px;
  margin: 50px auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-family: 'Merriweather', sans-serif;
}

/* Header with title on the left and pagination on the right */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin: 0;
  flex: 1 1;
  text-align: left;
}

/* Pagination styles */
.pagination {
  display: flex;
}

.page-button {
  background: #fff;
  border: 1px solid #ccc;
  padding: 5px 10px;
  margin-left: 5px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
}

.page-button:hover {
  background: #f0f0f0;
}

.page-button.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

/* Styling for each goal */
.post-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 15px;
  margin: 10px 0;
  border-radius: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.goal-text {
  font-size: 18px;
  text-align: left;
  flex: 1 1;
}

.goal-text.completed {
  text-decoration: line-through;
  color: gray;
}

.checkmark {
  font-size: 20px;
  color: green;
}`, "",{"version":3,"sources":["webpack://./src/PersonalGoals.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd","sourcesContent":[".container {\n  max-width: 600px;\n  margin: 50px auto;\n  padding: 20px;\n  background: #f9f9f9;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  font-family: 'Merriweather', sans-serif;\n}\n\n/* Header with title on the left and pagination on the right */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: bold;\n  color: #333;\n  margin: 0;\n  flex: 1;\n  text-align: left;\n}\n\n/* Pagination styles */\n.pagination {\n  display: flex;\n}\n\n.page-button {\n  background: #fff;\n  border: 1px solid #ccc;\n  padding: 5px 10px;\n  margin-left: 5px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.page-button:hover {\n  background: #f0f0f0;\n}\n\n.page-button.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n/* Styling for each goal */\n.post-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #fff;\n  padding: 15px;\n  margin: 10px 0;\n  border-radius: 10px;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.goal-text {\n  font-size: 18px;\n  text-align: left;\n  flex: 1;\n}\n\n.goal-text.completed {\n  text-decoration: line-through;\n  color: gray;\n}\n\n.checkmark {\n  font-size: 20px;\n  color: green;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
